// @flow

import React from 'react';
import type { ACFProps } from './types';
import ReviewContainer from './review';
import { List } from '../list';

export type Props = ACFProps;

const Review = ({
  template,
  variant,
  view,
  use_list,
  title,
  items,
}: Props) => {
  const itemList = typeof items === 'boolean' ? [] : items;

  return (
    <ReviewContainer
      url="/ervaringen"
      template={template}
      variant={variant}
      view={view}
    >
      {use_list && (
        <List
          className="review-list"
          listStyle="icons"
          subtitle={title}
          items={itemList}
          colorScheme="default"
          border=""
        />
      )}
    </ReviewContainer>
  );
};

export default Review;
